<div class="payment-step">
  <div class="payment-step__info">
    <div class="payment-step__info__icon"></div>
    <div class="payment-step__info__title" i18n>Your {{ company | lxCompanyFormattedName }} enrolment</div>
    <div class="payment-step__info__subtitle" i18n>Deposit payment required</div>
    <div class="payment-step__info__description">
      <div i18n>
        If your departure is in less than 30 days, a deposit of
        <ng-container *ngTemplateOutlet="formattedAmount"></ng-container>
        is required immediately to prioritize your application and ensure your trip proceeds as planned. Without this payment, your departure cannot be
        confirmed.
      </div>

      <div i18n>
        If your trip is more than 30 days away, the same deposit amount is still required to secure your place. Please note that enrolment is not finalized
        until the full payment is made and your chosen school confirms availability.
      </div>
    </div>
    <div *ngIf="paymentInfo" class="payment-step__summary">
      <ng-container *ngIf="paymentInfo.studentDetails as student">
        <div class="payment-step__summary__item">
          <span class="payment-step__summary__item__label" i18n>Full name:</span>
          <span class="payment-step__summary__item__data">{{ student.firstName }} {{ student.lastName }}</span>
        </div>

        <div class="payment-step__summary__item">
          <span class="payment-step__summary__item__label" i18n>Email address:</span>
          <span class="payment-step__summary__item__data">{{ student.email }}</span>
        </div>
      </ng-container>

      <div class="payment-step__summary__item">
        <span class="payment-step__summary__item__label" i18n>Deposit payable to secure your place:</span>
        <span class="payment-step__summary__item__data">
          <ng-container *ngTemplateOutlet="formattedAmount"></ng-container>
        </span>
      </div>
    </div>
    <lx-button
      (buttonClick)="pay()"
      [block]="true"
      [btnRounded]="true"
      buttonId="pay-online"
      buttonStyle="primary"
      class="payment-step__pay-cta"
      text="Pay online"
      i18n-text
    ></lx-button>

    <div class="payment-step__flywire">
      <span class="payment-step__flywire__text" i18n>Powered by </span>
      <img alt="Flywire" height="30" ngSrc="/assets/images/logo-flywire.svg" width="80" />
    </div>

    <div class="payment-step__payment-options">
      <img *ngFor="let option of paymentOptions" [alt]="option.alt" [ngSrc]="option.src" height="50" width="70" />
    </div>
  </div>
</div>
<ng-template #formattedAmount>
  {{
    paymentInfo?.depositAmounts
      | lxPrice
        : {
            currency: paymentInfo?.currency,
            minDecimalPlaces: 0
          }
  }}
</ng-template>
